import React, { useContext } from "react";
import Card from "./Card";
import styled from "@emotion/styled";
import Context from "../EventsProvider";
import Message from "../../IndexPage/Message";

//style rules
import { Sizes } from "../../../styles";

const Cards = () => {
	const { data: { message, language, items } } = useContext(Context);

	const noEventsText = () => {
		if (language === "en") return "No events found";
		return "Aucun événement trouvé";
	}

	if (message) return <Message text={message} />;

	if (items.length === 0) return <Message text={noEventsText()} />;

	return (
		<CardsList>
			<Card />
		</CardsList>
	)
};

export default Cards;

const CardsList = styled.ul`
	list-style: none;
	padding: unset;
	margin: 0 0 4rem 0;
	display: grid;
	row-gap: 3rem;
	grid-template-columns: 1fr;
	grid-auto-rows: auto;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 6rem 2.4rem;
    }
`;